import { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { toast } from "sonner";

const ImageUpload = ({ value, onChange, label }) => {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const r = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
      toast.success("Imagem enviada");
    } catch (err) {
      toast.error("Erro ao enviar imagem");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      {label && <label className="text-sm font-medium text-foreground mb-1 block">{label}</label>}
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative">
            <img src={fileUrl(value)} alt="" className="w-20 h-20 rounded-xl object-cover border border-border" />
            <button type="button" onClick={() => onChange("")} className="absolute -top-2 -right-2 bg-destructive text-white rounded-full p-1">
              <X className="w-3 h-3" />
            </button>
          </div>
        ) : (
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            data-testid="image-upload-btn"
            className="w-20 h-20 rounded-xl border-2 border-dashed border-border flex items-center justify-center text-muted-foreground hover:border-primary transition-colors"
          >
            {uploading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Upload className="w-5 h-5" />}
          </button>
        )}
        <div className="flex-1">
          <button type="button" onClick={() => inputRef.current?.click()} className="text-sm font-semibold text-primary">
            {value ? "Trocar imagem" : "Enviar imagem"}
          </button>
          <input
            type="text"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="ou cole uma URL"
            className="mt-1 w-full text-xs px-2 py-1.5 rounded-lg border border-border bg-background outline-none focus:border-primary"
          />
        </div>
      </div>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handle} />
    </div>
  );
};

export default ImageUpload;
